{
  "more_actions": {
    "removed_history": "Historique des suppressions",
    "list_settings": "Paramètres de la liste",
    "manage_columns": "Gérer les colonnes",
    "reminder": "Rappel",
    "add_comment": "Ajouter un commentaire"
  },
  "lists": {
    "name_required": "Veuillez saisir un nom de liste",
    "create_list": "Créer une liste",
    "name": "Nom",
    "rename": "Renommer la liste",
    "new_contact_list": "Nouvelle liste de contacts",
    "enable_duplicate_contacts": "Activer les contacts en double",
    "duplicate_contacts_tooltip": "Activer les contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation des données peuvent ne pas fonctionner correctement.",
    "more_actions": {
      "request_contacts": "Demander des contacts",
      "clean_list": "Nettoyer la liste",
      "connected_to": "Connecté à",
      "sync_with": "Synchroniser avec"
    }
  },
  "company_list": {
    "shared_company_list": "liste d'entreprises partagée",
    "personal_company_list": "liste d'entreprises personnelle",
    "project_company_list": "liste d'entreprises de projet",
    "list_memberships": "Adhésions aux listes",
    "import_companies": "Importer des entreprises",
    "add_company": "Ajouter une entreprise",
    "add_to_list": "Ajouter à la liste",
    "edit_company_type": "Modifier le type d'entreprise",
    "bulk_edit": "Modification en lot",
    "remove": "Supprimer",
    "list": "Liste",
    "company": "Entreprise",
    "add_company_to_list": "Ajouter une entreprise à la liste",
    "bulk_edit_custom_fields": "Modification en lot des champs personnalisés",
    "edit_custom_fields": "Modifier les champs personnalisés",
    "please_select_company": "Veuillez sélectionner une entreprise à ajouter à cette liste",
    "please_choose_list": "Veuillez choisir une liste",
    "which_company_placeholder": "Quelle entreprise voulez-vous ajouter à cette liste",
    "action_cannot_be_undone": "Cette action ne peut pas être annulée",
    "delete_tab_confirmation": "Êtes-vous sûr de vouloir supprimer cet onglet ?",
    "company_removed_from_list": "L'entreprise sera supprimée de cette liste.",
    "remove_company_confirmation": "Êtes-vous sûr de vouloir supprimer l'entreprise de cette liste ?",
    "remove_company_aria_label": "supprimer l'entreprise de cette liste",
    "loading_companies": "chargement des entreprises",
    "more_companies_contact_support": "Il y a plus d'entreprises que celles affichées. Veuillez contacter le support NEXL."
  },
  "my_lists": {
    "page": {
      "create_list": "Créer une liste",
      "search_placeholder": "Rechercher le nom de la liste",
      "lists_header": "Listes"
    },
    "navigation": {
      "other_lists": "Autres listes"
    },
    "empty_states": {
      "no_shared_list": "Aucune liste partagée",
      "your_list_is_empty": "Votre liste est vide",
      "no_lists_found": "Aucune liste trouvée",
      "no_search_results": "Nous n'avons trouvé aucune liste correspondant à votre recherche. Essayez d'utiliser des mots-clés différents ou créez une nouvelle liste"
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "list_actions": "Actions de liste",
      "rename_list": "Renommer la liste",
      "share_list": "Partager la liste",
      "add_company": "Ajouter une entreprise",
      "add_contact": "Ajouter un contact",
      "add_generic_item": "Ajouter un élément",
      "add_activity": "Ajouter une activité",
      "add_column": "Ajouter une colonne",
      "share": "Partager"
    },
    "forms": {
      "list_name": "Nom de la liste",
      "list_name_required": "Veuillez saisir un nom de liste",
      "invite": "Inviter",
      "invitee_required": "Veuillez choisir au moins un invité",
      "enable_duplicate_contacts": "Autoriser les contacts en double",
      "duplicate_contacts_tooltip": "L'activation des contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation de données peuvent ne pas fonctionner correctement."
    },
    "confirmations": {
      "archive_list_title": "Archiver la liste ?",
      "archive_list_content": "Êtes-vous sûr de vouloir archiver cette liste ? Elle sera supprimée de la liste.",
      "remove_user_title": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      "remove_user_content": "Cliquez sur confirmer pour supprimer"
    },
    "share": {
      "invite_tab": "Inviter",
      "access_tab": "Accès",
      "owner": "Propriétaire",
      "success_message": "Votre liste a été partagée avec succès. Nous informerons les destinataires.",
      "loading_users": "Chargement des utilisateurs"
    },
    "scopes": {
      "all": {
        "name": "Rechercher des listes",
        "description": "Recherchez une liste à laquelle vous avez accès ou sélectionnez parmi vos listes récemment consultées."
      },
      "created": {
        "name": "Créé par moi",
        "description": "Voici vos éléments récemment créés. Utilisez la recherche pour en trouver d'autres et restez organisé en suivant votre travail."
      },
      "shared": {
        "name": "Partagé avec moi",
        "description": "Recherchez pour trouver une liste ou sélectionnez parmi une de vos listes récentes partagées avec vous."
      },
      "workspace": {
        "name": "Listes d'espace de travail",
        "description": ""
      },
      "app": {
        "name": "Listes d'applications",
        "description": ""
      },
      "marketing": {
        "name": "Listes marketing",
        "description": ""
      }
    },
    "types": {
      "contact_list": "Créer une liste de contacts pour votre projet",
      "company_list": "Créer une liste d'entreprises pour votre projet",
      "generic_list": "Créer une liste personnalisée pour soutenir votre projet"
    },
    "empty_descriptions": {
      "shared": "Il semble que personne n'ait encore partagé de listes avec vous. Quand quelqu'un partage une liste, elle apparaîtra ici.",
      "marketing": "Commencez à créer votre liste sur Marketing pour les voir ici.",
      "app": "Commencez à créer votre liste sur Apps pour les voir ici.",
      "workspace": "Commencez à créer votre liste sur Workspace pour les voir ici.",
      "default": "Commencez à créer votre liste pour les voir ici."
    }
  },
  "company_list_grid": {
    "add_company": "Ajouter une entreprise",
    "add_to_list": "Ajouter à la liste",
    "edit_company_type": "Modifier le type d'entreprise",
    "bulk_edit": "Modification en lot",
    "remove": "Supprimer",
    "import_companies": "Importer des entreprises"
  },
  "removed_history": {
    "title": "Historique des suppressions",
    "empty_state": {
      "title": "Aucun contact supprimé",
      "description": "Aucun contact n'a encore été supprimé de cette liste. Une fois les contacts supprimés, ils apparaîtront ici."
    },
    "table": {
      "selected_count": "{{count}} sélectionné(s)",
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "removed_date": "Date de suppression",
        "removed_by": "Supprimé par"
      }
    },
    "actions": {
      "add_to_list": "Ajouter à la liste",
      "go_back_tooltip": "retourner à {{listName}}"
    }
  },
  "e_marketing_integration": {
    "settings": {
      "title": "Paramètres eMarketing",
      "sync_to_tools": "Synchroniser avec les outils eMarketing",
      "sync_to_tools_caption": "Chaque fois que vous synchronisez avec un outil eMarketing, une nouvelle liste sera créée dans leur application. Vous pouvez choisir quels champs mapper, en vous assurant que les bonnes données sont incluses."
    },
    "sync": {
      "title": "Synchroniser les contacts",
      "save_and_sync": "Sauvegarder et synchroniser",
      "connector_name": "Nom du connecteur",
      "e_marketing_list_name": "Nom de la liste eMarketing",
      "e_marketing_list_name_caption": "Si une liste avec le même nom existe dans l'outil eMarketing, elle sera écrasée.",
      "type_connector_name": "Tapez le nom du connecteur",
      "select_connector": "Sélectionner le connecteur",
      "syncing_tooltip": "La synchronisation des contacts avec l'outil eMarketing est en cours.",
      "syncing_status": "Synchronisation..."
    },
    "status": {
      "out_of_sync_title": "Liste non synchronisée.",
      "sync_now": "Synchroniser maintenant",
      "sync_now_description": "pour mettre à jour vos données.",
      "sync_complete_title": "Synchronisation terminée :",
      "sync_complete_description": "Votre liste de contacts a été synchronisée avec",
      "sync_failed_title": "Échec de la synchronisation :",
      "sync_failed_description": "Cela peut être dû à des problèmes de connexion ou à des paramètres incorrects. Ouvrez",
      "e_marketing_setup": "configuration eMarketing",
      "retry_description": "pour réessayer."
    },
    "disconnect": {
      "title": "Supprimer la connexion ?",
      "description": "Êtes-vous sûr de vouloir supprimer cette connexion ? Cette action supprimera l'intégration et toutes les synchronisations en cours seront arrêtées. Cette action ne peut pas être annulée.",
      "aria_label": "Supprimer la connexion",
      "button_title": "Supprimer la connexion"
    },
    "field_mapping": {
      "title": "Champs à mapper",
      "nexl_fields": "Champs Nexl",
      "concep_fields": "Champs Concep",
      "add_map_field": "Ajouter un champ de mappage",
      "select_nexl_field": "Sélectionner le champ Nexl",
      "select_remote_field": "Sélectionner le champ distant",
      "remove_field_mapping": "Supprimer le mappage de champ {{index}}"
    }
  },
  "list_cleaner": {
    "status_result": "Résultat du statut",
    "last_verified": "Dernière vérification",
    "verify_list": {
      "button": "Vérifier la liste",
      "verifying": "Vérification de la liste",
      "confirmation_title": "Vérifier la liste",
      "confirmation_content": "Validez les adresses e-mail pour leur exactitude avant d'envoyer des campagnes."
    },
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Entreprise",
        "location": "Localisation",
        "last_interaction": "Dernière interaction",
        "consent_status": "Statut de consentement",
        "reason": "Raison",
        "result": "Résultat",
        "status": "Statut",
        "action": "Action"
      },
      "selected_count": "{{count}} sélectionné(s)"
    },
    "actions": {
      "mark_as_low_risk": "Marquer comme faible risque",
      "remove_from_list": "Supprimer de la liste",
      "list_cleaner_actions": "actions de nettoyage de liste"
    },
    "contact_status": {
      "bounced": "Supprimer les rebonds",
      "consent_not_given": "Supprimer de la liste",
      "total": "Supprimer de la liste",
      "unengaged": "Supprimer les non-engagés",
      "user_unsubscribed": "Supprimer les désabonnés"
    },
    "risk": {
      "high_risk": "Risque élevé",
      "medium_risk": "Risque moyen",
      "low_risk": "Faible risque",
      "unknown_risk": "Risque inconnu",
      "risk_with_level": "{{level}} RISQUE",
      "tooltips": {
        "high": "L'envoi à cette adresse très risquée nuira à votre réputation.",
        "medium": "Il s'agit de notre niveau de risque neutre. Les e-mails non classés comme risque faible ou élevé sont par défaut à risque moyen.",
        "low": "L'adresse e-mail est probablement valide et l'envoi présente un faible risque pour votre réputation."
      }
    },
    "confirmations": {
      "mark_low_risk_title": "Marquer comme faible risque ?",
      "mark_low_risk_content": "Une fois marqué comme faible risque, le statut de ce contact ne peut pas être modifié jusqu'à ce que le système réévalue dans 3 mois. Confirmez-vous cette action ?",
      "remove_from_list_title": "Supprimer de la liste ?",
      "remove_from_list_single": "Ce contact sera supprimé de votre liste.",
      "remove_from_list_multiple": "Ces contacts seront supprimés de votre liste.",
      "remove_all_contacts_title": "Supprimer tous les contacts {{type}} de la liste ?",
      "remove_all_contacts_content": "Ces contacts seront supprimés de votre liste."
    },
    "success": {
      "contacts_cleaned_title": "Contacts {{type}} nettoyés !",
      "contacts_cleaned_description": "Tous les contacts {{type}} ont été supprimés. Votre liste est maintenant plus efficace et livrable !"
    },
    "remove_cleaned": {
      "ok": "Ok"
    }
  },
  "contact_list_grid": {
    "actions": {
      "add_contact": "Ajouter un contact",
      "import_contacts": "Importer des contacts",
      "export": "Exporter",
      "refresh": "Actualiser",
      "share": "Partager",
      "sync_contacts": "Synchroniser les contacts",
      "syncing": "Synchronisation",
      "add_tags": "Ajouter des étiquettes",
      "bulk_edit": "Modification en lot",
      "log_new_activity": "Enregistrer une nouvelle activité"
    },
    "sync": {
      "failed": "Échec de la synchronisation",
      "try_again": "Réessayer",
      "out_of_sync": "Liste non synchronisée. Synchronisez maintenant pour mettre à jour vos données.",
      "complete": "Synchronisation terminée : Votre liste de contacts a été synchronisée avec {{campaignManagerName}} !",
      "in_progress": "Synchronisation de la liste, cela peut prendre quelques minutes..."
    },
    "status": {
      "loading_contacts_aria": "chargement des contacts",
      "error_prefix": "Erreur : {{message}}",
      "over_limit": "Cette liste dépasse la limite, affichage de {{count}} seulement.",
      "outdated_list": "La liste que vous consultez est obsolète, cliquez sur actualiser pour voir les dernières modifications."
    },
    "tooltips": {
      "duplicate_contacts": "L'activation des contacts en double permet plusieurs entrées dans les formulaires. Cependant, veuillez noter que l'importation et l'exportation de données peuvent ne pas fonctionner correctement."
    }
  },
  "expiry": {
    "description": "Définir une condition pour fermer automatiquement les soumissions de formulaire.",
    "enable_label": "Activer la date d'expiration",
    "date_label": "Date d'expiration",
    "date_placeholder": "Quand le formulaire expirera-t-il ?",
    "page_header_label": "En-tête de la page d'expiration",
    "page_header_placeholder": "Veuillez saisir l'en-tête de la page d'expiration",
    "page_description_label": "Description de la page d'expiration",
    "default_header": "Le formulaire a expiré",
    "default_description": "Ce formulaire a expiré et ne peut plus être consulté. Veuillez contacter le propriétaire du formulaire pour obtenir de l'aide.",
    "validation": {
      "date_required": "Veuillez sélectionner une date d'expiration",
      "date_past": "La date et l'heure ne peuvent pas être dans le passé",
      "header_required": "Veuillez saisir l'en-tête de la page d'expiration"
    }
  },
  "views": {
    "default_view": "Vue par défaut",
    "views_label": "Vues",
    "create_view": "Créer une vue",
    "edit_view": "Modifier la vue",
    "delete_view": "Supprimer la vue",
    "share_view": "Partager la vue",
    "view_name_label": "Nom de la vue",
    "view_actions_aria": "actions de vue pour {{viewName}}",
    "select_view_aria": "Sélectionner la vue {{viewType}}",
    "choose_single_select_column": "Choisir une colonne de sélection unique",
    "choose_column": "Choisir une colonne",
    "single_select_tooltip": "Fait référence à un type de champ qui permet aux utilisateurs de choisir une seule option parmi un ensemble d'options prédéfinies",
    "view_types": {
      "list": "Liste",
      "board": "Tableau",
      "calendar": "Calendrier",
      "timeline": "Chronologie",
      "unknown": "{{new_type}}"
    },
    "permissions": {
      "read_only": "Lecture seule",
      "edit_description": "Autorisé à modifier la liste et ajouter de nouveaux contacts",
      "read_only_description": "Autorisé à voir la liste et les détails des contacts mais ne peut pas apporter de modifications",
      "anyone_can_edit": "Toute personne avec le lien peut modifier",
      "anyone_can_view": "Toute personne avec le lien peut voir",
      "anyone_can_read_only": "Toute personne avec le lien peut voir en lecture seule"
    },
    "share": {
      "share_view_title": "Partager la vue",
      "item_label": "Élément",
      "permission_label": "Permission",
      "copy_link": "Copier le lien",
      "link_copied": "Lien copié !",
      "invite_member": "Inviter un membre",
      "link_copied_tooltip": "Lien copié !",
      "copy_link_description": "Entrez l'email ou le nom de l'utilisateur pour partager une vue, ou copiez",
      "this_link": "ce lien",
      "to_share": "pour partager.",
      "copy_link_aria": "copier ce lien pour partager",
      "success_message": "La vue de liste a été partagée avec succès. Nous informerons les destinataires.",
      "create_new_view_message": "Créer une nouvelle vue à partager",
      "invite_required": "Veuillez inviter au moins un membre"
    },
    "confirmations": {
      "delete_content": "Cliquez sur confirmer pour supprimer la vue"
    },
    "validation": {
      "name_required": "Veuillez saisir un nom"
    }
  },
  "all_or_my_external_filter": {
    "all": "Tout",
    "my_contacts": "Mes contacts",
    "all_contacts_aria": "Afficher tous les contacts",
    "my_contacts_aria": "Afficher mes contacts",
    "my_companies": "Mes entreprises",
    "all_companies_aria": "Afficher toutes les entreprises",
    "my_companies_aria": "Afficher mes entreprises"
  },
  "forms": {
    "link_campaign": {
      "title": "Lier la campagne à un formulaire",
      "description": "Obtenez le lien du formulaire à ajouter à votre campagne",
      "button": "Lier le formulaire",
      "generating": "Génération de l'URL",
      "no_url_error": "Aucune URL trouvée. Veuillez contacter le support."
    },
    "prefill": {
      "label": "Pré-remplir les champs du formulaire",
      "tooltip": "Lorsque activé, les informations de contact de votre campagne rempliront automatiquement les champs du formulaire"
    },
    "form_selection": {
      "label": "Formulaire",
      "placeholder": "Veuillez sélectionner un formulaire",
      "generate_link": "Générer le lien"
    },
    "add": {
      "title": "FORMULAIRE",
      "label": "Formulaire",
      "button": "Ajouter un formulaire",
      "contact_list_form": "Formulaire de liste de contacts"
    },
    "empty": {
      "message": "Commencez à créer un nouveau formulaire ici."
    },
    "rename": {
      "placeholder": "Entrez le nom du formulaire"
    },
    "actions": {
      "edit": "Modifier",
      "rename": "Renommer",
      "copy_link": "Copier le lien du formulaire pour EMS"
    },
    "delete": {
      "confirmation": "Êtes-vous sûr de vouloir supprimer ce formulaire ?",
      "title": "Supprimer le formulaire",
      "button": "Supprimer"
    },
    "status": {
      "expired": "Expiré",
      "draft": "Brouillon",
      "unpublished_changes": "Modifications non publiées",
      "published": "Publié"
    },
    "preview": {
      "loading": "Chargement du formulaire...",
      "redirecting": "Redirection...",
      "required_fields_empty": "Les champs obligatoires sont vides",
      "submit": "Soumettre",
      "supported_by": "Pris en charge par",
      "display_not_supported": "Affichage non pris en charge"
    }
  }
}
